<script setup lang="ts">
import type { StudioContactType } from '@terapeut-ia/shared-types'

defineProps<{
  type: StudioContactType | 'PRIVACY'
}>()
</script>

<template>
  <svg
    v-if="type === 'INSTAGRAM'"
    viewBox="0 0 24 24"
    aria-hidden="true"
    fill="none"
    stroke="currentColor"
    stroke-width="1.8"
  >
    <rect x="3" y="3" width="18" height="18" rx="5" />
    <circle cx="12" cy="12" r="4.1" />
    <circle cx="17.4" cy="6.8" r="1" fill="currentColor" stroke="none" />
  </svg>
  <svg
    v-else-if="type === 'WHATSAPP'"
    viewBox="0 0 24 24"
    aria-hidden="true"
    fill="none"
    stroke="currentColor"
    stroke-width="1.8"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path d="M20.5 11.7a8.5 8.5 0 0 1-12.6 7.4L3.5 20.5l1.4-4.2a8.5 8.5 0 1 1 15.6-4.6Z" />
    <path d="M8.5 7.8c.3-.5.6-.5.9-.5h.4c.2 0 .4.1.5.4l.9 2c.1.3.1.5-.1.7l-.7.8c-.2.2-.1.5 0 .7.7 1.2 1.7 2.2 3 2.8.3.2.5.1.7-.1l.8-1c.2-.2.4-.3.7-.2l2 .9c.3.1.4.3.4.6 0 .7-.3 1.5-.9 2-.6.5-1.4.8-2.4.6-1.5-.3-3.5-1.2-5.3-2.9-1.5-1.5-2.5-3.2-2.8-4.6-.2-.9.1-1.7.5-2.2Z" />
  </svg>
  <svg v-else-if="type === 'PHONE'" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M7.4 3.5 10 7.8 8.4 9.4c1.2 2.5 3.1 4.4 5.6 5.6l1.6-1.6 4.3 2.6c.4.2.6.7.5 1.1-.4 2-2.2 3.5-4.3 3.4C9.4 20.1 3.9 14.6 3.5 7.9 3.4 5.8 4.9 4 6.9 3.6c.2-.1.4-.1.5-.1Z" />
  </svg>
  <svg v-else-if="type === 'EMAIL'" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <rect x="3" y="5" width="18" height="14" rx="3" />
    <path d="m4.5 7 7.5 5.5L19.5 7" />
  </svg>
  <svg v-else-if="type === 'ADDRESS'" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M20 10c0 5-8 11-8 11S4 15 4 10a8 8 0 1 1 16 0Z" />
    <circle cx="12" cy="10" r="2.5" />
  </svg>
  <svg v-else-if="type === 'FACEBOOK'" viewBox="0 0 24 24" aria-hidden="true" fill="currentColor">
    <path d="M13.7 21v-8h2.7l.4-3h-3.1V8.1c0-.9.3-1.5 1.6-1.5H17V4c-.3 0-1.3-.1-2.4-.1-2.4 0-4 1.4-4 4.1v2H8v3h2.6v8h3.1Z" />
  </svg>
  <svg v-else-if="type === 'YOUTUBE'" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round">
    <path d="M21 12c0-2.2-.2-4.3-.5-5.1-.2-.7-.8-1.3-1.5-1.5C17.6 5 14.8 5 12 5s-5.6 0-7 .4c-.7.2-1.3.8-1.5 1.5C3.2 7.7 3 9.8 3 12s.2 4.3.5 5.1c.2.7.8 1.3 1.5 1.5 1.4.4 4.2.4 7 .4s5.6 0 7-.4c.7-.2 1.3-.8 1.5-1.5.3-.8.5-2.9.5-5.1Z" />
    <path d="m10 9 5 3-5 3V9Z" fill="currentColor" stroke="none" />
  </svg>
  <svg v-else-if="type === 'PRIVACY'" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M12 3 5 6v5c0 4.6 2.8 8.3 7 10 4.2-1.7 7-5.4 7-10V6l-7-3Z" />
    <path d="m9 12 2 2 4-4" />
  </svg>
  <svg v-else viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M10 13a5 5 0 0 0 7.1.1l2-2a5 5 0 0 0-7.1-7.1l-1.1 1.1" />
    <path d="M14 11a5 5 0 0 0-7.1-.1l-2 2A5 5 0 0 0 12 20l1.1-1.1" />
  </svg>
</template>
